import { render, staticRenderFns } from "./scroll-bar.vue?vue&type=template&id=3d369cd2"
import script from "./scroll-bar.vue?vue&type=script&lang=js"
export * from "./scroll-bar.vue?vue&type=script&lang=js"
import style0 from "./scroll-bar.vue?vue&type=style&index=0&id=3d369cd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports